module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 23\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#9ECAFF\" d=\"M3 3.64a2.5 2.5 0 0 0-2.5 2.5V20A2.5 2.5 0 0 0 3 22.5h9.72a2.5 2.5 0 0 0 2.5-2.5V6.14a2.5 2.5 0 0 0-2.5-2.5H3z\"/><path stroke=\"#9ECAFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5 13l2.99 2.99L10.98 13\"/><path stroke=\"#9ECAFF\" stroke-linecap=\"square\" d=\"M16.22 19.86c.77 0 1.4-.62 1.4-1.4V2.82a2 2 0 0 0-2-2H4.92c-.99 0-1.78.8-1.78 1.78\"/><rect width=\"1\" height=\"6\" x=\"7.5\" y=\"10\" fill=\"#9ECAFF\" rx=\".5\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/download-file.svg
// module id = 6EvK
// module chunks = 5